<template>
  <div :id="id" :style="{ height: height, width: width }"></div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
// let color = []
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null,
      defaultOptions: {}
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      const isAndroid = this.$store.state.app.isAndroid
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      const pieOption = {
        title: this.option.title || {},
        legend: {
          icon: 'circle',
          itemWidth: !isAndroid ? 10 : 5,
          itemHeight: !isAndroid ? 10 : 5,
          itemGap: 8,
          top: !isAndroid ? 10 : 20,
          right: 20,
          textStyle: {
            fontSize: !isAndroid ? 12 : 8,
            color: '#F1F1F3'
          },
          ...this.option.legend
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        color: this.option.color ? this.option.color : ['#0099FF', '#FF5A18', '#00B790', '#06C49C', '#FFB000', '#FA4300', '#FFFFFF', '#A352FF', '#3ED5FF', '#F07028'],
        grid: this.option.grid || {
          left: 10,
          right: 20,
          bottom: 10,
          top: 20,
          containLabel: true
        },
        xAxis: this.option.xAxis && this.option.xAxis.length > 0 ? this.option.xAxis : [
          {
            type: 'category',
            boundaryGap: !!this.option.boundaryGap,
            data: this.option.xData,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)'
              }
            },
            axisLabel: {
              // rotate: 90,
              textStyle: {
                color: 'rgba(255,255,255,.6)',
                fontSize: !isAndroid ? 12 : 10
              }
            },
            axisTick: {
              alignWithLabel: !!this.option.alignWithLabel
            },
            ...this.option.xAxis
          }
        ],
        yAxis: this.option.yAxis && this.option.yAxis.length > 0 ? this.option.yAxis : [
          {
            type: 'value',
            min: this.option.min ? this.option.min : 0,
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,.1)'
              }
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(255,255,255,.6)',
                fontSize: !isAndroid ? 12 : 10
              }
            },
            nameTextStyle: {
              color: '#999',
              fontSize: !isAndroid ? 12 : 10
            },
            splitNumber: 2,
            ...this.option.yAxis
          }
        ],
        series: this.option.series
      }
      this.chart.setOption(pieOption)
    }
  },
  created () {}
}
</script>
